var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73443 11.4629L0.110135 7.84777C-0.0367116 7.70353 -0.0367116 7.4703 0.110135 7.32606L0.331966 7.10818C0.478813 6.96394 0.716266 6.96394 0.863113 7.10818L4 10.2476L7.13689 7.11125C7.28373 6.96701 7.52119 6.96701 7.66803 7.11125L7.88987 7.32913C8.03671 7.47337 8.03671 7.7066 7.88987 7.85084L4.26557 11.4659C4.11873 11.6071 3.88127 11.6071 3.73443 11.4629Z",
    fill: "#C1C2C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26557 0.108668L7.88987 3.72377C8.03671 3.868 8.03671 4.10123 7.88987 4.24547L7.66803 4.46336C7.52119 4.60759 7.28373 4.60759 7.13689 4.46336L4 1.32393L0.863112 4.46029C0.716266 4.60452 0.478812 4.60452 0.331966 4.46029L0.110134 4.2424C-0.0367117 4.09816 -0.0367116 3.86493 0.110134 3.7207L3.73443 0.105599C3.88127 -0.0355681 4.11873 -0.0355681 4.26557 0.108668Z",
    fill: "#C1C2C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowVertical);
export default __webpack_public_path__ + "static/media/arrow-vertical.4a7188a7b6e2df61a6cf0fbaafd33ba7.svg";
export { ForwardRef as ReactComponent };